__turbopack_context__.v({
  "attentionNiceClose": "e3rORW_attentionNiceClose",
  "buttonClose": "e3rORW_buttonClose",
  "emptyList": "e3rORW_emptyList",
  "iconClose": "e3rORW_iconClose",
  "isDark": "e3rORW_isDark",
  "isHideXs": "e3rORW_isHideXs",
  "isLoading": "e3rORW_isLoading",
  "isSelected": "e3rORW_isSelected",
  "isShowXs": "e3rORW_isShowXs",
  "isVisible": "e3rORW_isVisible",
  "list": "e3rORW_list",
  "loader": "e3rORW_loader",
  "mktuNumberButton": "e3rORW_mktuNumberButton",
  "mktuNumberList": "e3rORW_mktuNumberList",
  "mktuNumberTitle": "e3rORW_mktuNumberTitle",
  "popup": "e3rORW_popup",
  "popupContainer": "e3rORW_popupContainer",
  "popupContent": "e3rORW_popupContent",
  "popupFooter": "e3rORW_popupFooter",
  "popupHeader": "e3rORW_popupHeader",
  "resetAllIcon": "e3rORW_resetAllIcon",
  "search": "e3rORW_search",
  "searchInput": "e3rORW_searchInput",
  "selectedCount": "e3rORW_selectedCount",
  "selectedWordsList": "e3rORW_selectedWordsList",
  "switchNice": "e3rORW_switchNice",
  "title": "e3rORW_title",
  "withoutBorder": "e3rORW_withoutBorder",
});
